import { useContext } from 'react';

import { LayoutCard, Skeleton, Stack } from '@cast/design-system';
import {
  PolicyStatus,
  WorkloadDetailsContext,
} from '@cast/split-me/features/cluster/workload-optimization';

import { InventoryWorkloadOptimizationStatus } from './InventoryWorkloadOptimizationStatus';
import { InventoryWorkloadScalingPolicySelect } from './InventoryWorkloadScalingPolicySelect';

export const InventoryWorkloadPolicyCard = () => {
  const { workload } = useContext(WorkloadDetailsContext);

  return (
    <LayoutCard testId="inventory-workload-policy-card">
      <Stack
        display="grid"
        gridTemplateColumns="1fr auto 1fr"
        gap={24}
        alignItems="stretch"
      >
        {workload ? (
          <InventoryWorkloadOptimizationStatus />
        ) : (
          <Stack gap={4} width="100%">
            <Skeleton height={20} width="30%" />
            <Skeleton height={40} width="100%" />
          </Stack>
        )}
        <Stack justifyContent="center" alignSelf="center">
          {workload ? (
            <PolicyStatus workload={workload} />
          ) : (
            <Skeleton height={40} width={40} />
          )}
        </Stack>
        <InventoryWorkloadScalingPolicySelect />
      </Stack>
    </LayoutCard>
  );
};
